/** Gambar stock yang sudah diverifikasi masih aktif di Unsplash */
export const IMAGES = {
  factory: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200&q=80",
  factoryHero: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=2000&q=80",
  collagen: "https://images.unsplash.com/photo-1689841175766-a5abc64b9903?w=1200&q=80",
  coffee: "https://images.unsplash.com/photo-1610632380989-680fe40816c6?w=1200&q=80",
  herbal: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=1200&q=80",
  fiber: "https://images.unsplash.com/photo-1610970881699-44a5587cabec?w=1200&q=80",
  tea: "https://images.unsplash.com/photo-1556679343-c7306c1976bc?w=1200&q=80",
  chocolate: "https://images.unsplash.com/photo-1542990253-a781e04c0082?w=1200&q=80",
  lab: "https://images.unsplash.com/photo-1579165466991-467135ad3110?w=1200&q=80",
  qc: "https://images.unsplash.com/photo-1616996691748-3f5f78093ab0?w=1200&q=80",
  production: "https://images.unsplash.com/photo-1511920170033-f8396924c348?w=1200&q=80",
};
